import * as React from 'react';
import { styles } from './styles';
import { cx } from 'emotion';

interface Props {
  className?: any;
}

export const PopupContent: React.SFC<Props> = ({ children, className }) => {
  const classNames = cx('popup__content', styles.container, className);
  return <div className={classNames}>{children}</div>;
};
